import React from "react"
import { Link, graphql } from "gatsby"
import commentBox from 'commentbox.io';

import Layout from "../components/layout"
import SEO from "../components/seo"
import TagsList from '../components/taglist'
import SocialShare from '../components/socialshare'

class BlogPostTemplate extends React.Component {
  
  componentDidMount() {
    commentBox('5667533860372480-proj')
  }

  render() {
    const post = this.props.data.markdownRemark
    const siteTitle = this.props.data.site.siteMetadata.title
    const siteUrl = this.props.data.site.siteMetadata.siteUrl
    const author = this.props.data.site.siteMetadata.author
    const { previous, next } = this.props.pageContext

    //console.log(this.props.data.site.siteMetadata)

    let disqusConfig = {
      identifier: post.frontmatter.title,
    }


    return (
      <Layout location={this.props.location} title={siteTitle}>
        <SEO
          title={post.frontmatter.title}
          description={post.frontmatter.description || post.excerpt}
        />
        <article>
          <header>
            <h1 className="postTitle">
              {post.frontmatter.title}
            </h1>
            <p className="postMeta">
              Posted on {post.frontmatter.date} <TagsList tags={post.frontmatter.tags} />
            </p>
          </header>
          <section dangerouslySetInnerHTML={{ __html: post.html }} />
        </article>
        <hr />
        <SocialShare siteUrl={siteUrl} location={this.props.location.pathname} title={post.frontmatter.title} />
        <div style={{ paddingBottom: "105px" }} />
        {/* <Disqus config={disqusConfig} /> */}
        <div className="commentbox" />
        <nav>
          <ul>
            <li>
              {previous && (
                <Link to={"/blog" + previous.fields.slug} rel="prev">
                  ← {previous.frontmatter.title}
                </Link>
              )}
            </li>
            <li>
              {next && (
                <Link to={"/blog" + next.fields.slug} rel="next">
                  {next.frontmatter.title} →
                </Link>
              )}
            </li>
          </ul>
        </nav>
      </Layout>
    )
  }
}

export default BlogPostTemplate

export const pageQuery = graphql`
  query BlogPostBySlug($slug: String!) {
    site {
      siteMetadata {
        title
        author
        siteUrl
      }
    }
    markdownRemark(fields: { slug: { eq: $slug } }) {
      id
      excerpt(pruneLength: 160)
      html
      frontmatter {
        title
        date(formatString: "MMMM DD, YYYY")
        draft
        tags
      }
    }
  }
`
